// extracted by mini-css-extract-plugin
export var statItem = "_ie-1";
export var statsRow = "_ie-0";